import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Title')(
  css({
    display: 'flex',
  }),
);

themeStyles.addBaseStyles('StyledTooltip')(({ styles }) =>
  css({
    display: 'inline-flex',
    verticalAlign: 'top',
    ml: '8px',
    ...styles,
  }),
);

export default themeStyles;
